import { render, staticRenderFns } from "./PlpAllSelectedRefinements.vue?vue&type=template&id=48f48bba&scoped=true&"
import script from "./PlpAllSelectedRefinements.vue?vue&type=script&lang=js&"
export * from "./PlpAllSelectedRefinements.vue?vue&type=script&lang=js&"
import style0 from "./PlpAllSelectedRefinements.vue?vue&type=style&index=0&id=48f48bba&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f48bba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlpChip: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/PlpChip.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
